import React, { Component } from 'react';
import * as Progress    from 'react-native-progress';
import * as ImagePicker from 'expo-image-picker';
import LottieView       from 'lottie-react-native';
import { SafeAreaView, StyleSheet, View, Image, TouchableOpacity, Linking, Platform } from 'react-native';
import { config } from '../../config';
import { Routes, Screen, Text, Line, Button } from '../components';
import { Link } from "react-router-native";
import UserController from '../controllers/userController';
import AsyncStorage   from '@react-native-async-storage/async-storage';

class WebLandingScreen extends Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    let is_first_sign_up = await AsyncStorage.getItem("first_sign_up");

    // if (Platform.OS === 'web' && is_first_sign_up && is_first_sign_up === 'yes') {
    if (Platform.OS === 'web') {
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');

       fbq('init', '1421996844904147');
       fbq('track', 'Subscribe');
    }
  }

  render() {
    return (
      <Screen navigation={this.props.navigation} hide_nav_bar={true} scroll={true}>
        <View style={{ width: "100%", alignItems: 'center', padding: 20 }}>
          <View style={{ paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, borderRadius: 15 }}>
            <Image style={{ height: 35, width: 200 }} resizeMode='contain' source={ require('../assets/images/dodovet-top-logo.png') } />
          </View>
        </View>
        <View style={{ alignItems: 'center' }}>
          <View style={{ width: 300, marginBottom: 20 }}>
            <Text style={{ fontSize: 18, fontWeight: '500', textAlign: 'center' }}>Welcome! Download the DodoVet app on your mobile device to access 24/7 care.</Text>
          </View>

          <View style={{ flexDirection: 'row' }}>
            <View style={{ width: 5 }}></View>
            <TouchableOpacity onPress={ () => {
                                Linking.openURL('https://apps.apple.com/us/app/dodovet/id1616028009')
                              }}>
              <Image style={{ height: 50, width: 140 }} resizeMode='contain' source={ 'https://teletailstest.s3.amazonaws.com/profile/1578674518619.png' } />
            </TouchableOpacity>
            <View style={{ width: 5 }}></View>
            <TouchableOpacity onPress={ () => {
                                Linking.openURL('https://play.google.com/store/apps/details?id=com.teletailscaremobile')
                              }}>
              <Image style={{ height: 50, width: 155 }} resizeMode='contain' source={ 'https://teletailstest.s3.amazonaws.com/profile/1578676143466.png' } />
            </TouchableOpacity>
          </View>
        </View>

        <Line style={{ marginTop: 20, marginBottom: 20 }}/>

        <View style={{ alignItems: 'center' }}>
          <Button title='Text Me iOS Download Link'
                  style={{ width: 360, borderRadius: 5, height: 50, marginBottom: 10 }}
                  onPress={ async () => {
                    let request_body = {
                      is_ios: true,
                      is_android: false
                    }

                    let text_link_res = await UserController.textAppDownloadLink(request_body);
                  }}/>
          <Button title='Text Me Android Download Link'
                  style={{ width: 360, borderRadius: 5, height: 50 }}
                  onPress={ async () => {
                    let request_body = {
                      is_ios: false,
                      is_android: true
                    }

                    let text_link_res = await UserController.textAppDownloadLink(request_body);
                  }}/>
        </View>
      </Screen>
    );
  }

}

const styles = StyleSheet.create({
  pets_section_container: {
    padding: 15,
    paddingBottom: 0
  },
  consult_btn_container: {
    padding: 15
  }
});

export default WebLandingScreen
